export default "__VITE_ASSET__CA3my3vP__"